module.exports = __webpack_public_path__ + "img/5F1827_9B4A60_1F0404_340406-256px.fef06618.png";